import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const FAQSection = () => {
  const [openItem, setOpenItem] = useState(null);
  const faqs = [{
    id: 1,
    question: 'How do I know if a coupon is valid?',
    answer: 'All coupons on KODIFY are verified before being published. You can check the expiration date on each coupon card. If a coupon is marked as "Expired", it can no longer be used.'
  }, {
    id: 2,
    question: "What if my coupon doesn't work?",
    answer: 'If a coupon doesn\'t work, it might be expired, have usage restrictions, or be limited to specific products. Contact us through the "Contact" link in the footer and we\'ll help you resolve the issue.'
  }, {
    id: 3,
    question: 'How do I redeem my discount?',
    answer: 'Click the "Copy Code" button on any coupon card to copy the discount code to your clipboard. Then paste it in the coupon or promo code field during checkout at the merchant\'s website.'
  }];
  const toggleItem = id => {
    setOpenItem(openItem === id ? null : id);
  };
  return <section className="my-12" id="faq" data-id="element-59">
      <h2 className="text-lg font-bold mb-6" data-id="element-60">FAQ</h2>
      <div className="space-y-4" data-id="element-61">
        {faqs.map(faq => <div key={faq.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-62">
            <button className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50" onClick={() => toggleItem(faq.id)} aria-expanded={openItem === faq.id} data-id="element-63">
              <span className="font-medium" data-id="element-64">{faq.question}</span>
              {openItem === faq.id ? <ChevronUpIcon size={20} data-id="element-65" /> : <ChevronDownIcon size={20} data-id="element-66" />}
            </button>
            {openItem === faq.id && <div className="p-4 bg-gray-50 border-t border-gray-200" data-id="element-67">
                <p className="text-sm text-gray-700" data-id="element-68">{faq.answer}</p>
              </div>}
          </div>)}
      </div>
    </section>;
};